import React, { useState } from 'react';
import { get, keyBy, uniq } from 'lodash';
import axios from 'axios';
import cn from 'classnames';
import Modal from './Modal'
import { useModal } from '../hooks'

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers'

import {
  canEdit,
  canKenta
} from '../lib/policies'

import { useCheckIds } from '../hooks'

import PostsListItem from './PostsListItem'
import BulkEditInformationModal from './BulkEditInformationModal'
import BulkPenaltyTools from './BulkPenaltyTools'

const PostsList = ({
  posts = [],
  total = 0,
}) => {
  const {
    checkIds,
    renderCheckBox,
    renderCheckBoxForCheckAll,
    renderOpenAllButton,
    shouldDisableAction,
  } = useCheckIds({
    data: posts,
    openUrl: 'posts',
  })

  const [showEditModal, setShowEditModal] = useState(false)

  const [
    reportModal,
    reportModalSet,
  ] = useModal({
    keyboardBindings: true,
  })

  const bulkDelete = () => {
    if (checkIds.length > 0) {
      requestCallback(axios.delete(`/${gon.currentProvider}/api/bulk/posts`, {
        data: {
          ids: checkIds,
          authenticity_token: CSRF_TOKEN
        }
      }))
    }
  }

  const bulkReport = (reportedCount) => {
    requestCallback(axios.post(`/${gon.currentProvider}/api/bulk/posts/report`, {
      ids: checkIds,
      reported_count: reportedCount,
      authenticity_token: CSRF_TOKEN
    }))
  }

  const openEditModal = () => {
    if (checkIds.length > 0) {
      setShowEditModal(true)
    }
  }

  const openReportModal = () => {
    if (checkIds.length > 0) {
      reportModalSet(true)
    }
  }

  const retrieveUserIdsFromPostIds = (postIds = []) => {
    const postsById = keyBy(posts, 'id')
    return uniq(postIds.map(id => get(postsById, `${id}.user.id`)).filter(id => typeof id !== 'undefined'))
  }

  const isHiding = (reportedCount) => {
    return reportedCount >= 3
  }

  return (
    <React.Fragment>
      <BulkEditInformationModal
        title="Bulk Edit Post"
        isActive={showEditModal}
        templateApiUrl="/api/post_templates"
        bulkUpdateApiUrl={`/${gon.currentProvider}/api/bulk/posts`}
        updatedIds={checkIds}
        updatedAtField="text"
        onClose={() => setShowEditModal(false)}
      />
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Posts</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} posts</p>
        </div>
        {renderOpenAllButton()}
      </div>

      <div className='TableChecker'>
        {renderCheckBoxForCheckAll()}

        <div className='TableChecker__right'>
          {canEdit('Post') && (
            <a
              onClick={openReportModal}
              className="TableChecker__right__a TableChecker__right__a--flag"
              title="Report"
              disabled={shouldDisableAction}
            />
          )}
          {canEdit('Post') && (
            <a
              onClick={openEditModal}
              className="TableChecker__right__a TableChecker__right__a--pencil"
              title="Edit"
              disabled={shouldDisableAction}
            />
          )}
          {canEdit('Post') && (
            <a
              onClick={bulkDelete}
              className="TableChecker__right__a TableChecker__right__a--trash"
              title="Delete"
              disabled={shouldDisableAction}
            />
          )}

          {canKenta('User') && (
            <BulkPenaltyTools
              userIds={retrieveUserIdsFromPostIds(checkIds)}
            />
          )}
        </div>
      </div>

      <div className='Posts'>
        {posts.map((post, i) => (
          <div
            className={cn('Posts__item', {
              'Posts__item--pinned': get(post, 'isPinned') ,
              'Posts__item--hiding': isHiding(get(post, 'reportedCount', 0))
            })}
            key={i}
            data-x={post}
          >
            <PostsListItem
              post={post}
              renderCheckBox={renderCheckBox}
            />

            {get(post, 'inReplyToPost') &&
              <PostsListItem
                post={get(post, 'inReplyToPost')}
                renderCheckBox={renderCheckBox}
                isAReply
              />
            }
          </div>
        ))}
      </div>

      <Modal
        isActive={reportModal}
        onToggleModal={() => {
          reportModalSet(false)
        }}
      >
        <div className='BannedWordModal'>
          <h3 className='Modal__h3'>Update report count</h3>

          <form
            className='BannedWordModal__form'
            onSubmit={(e) => {
              e.preventDefault()
              const $els = e.target.elements
              const reportCount = get($els, 'reported_count.value').trim()

              requestCallback(bulkReport(reportCount))
            }}
          >
            <input
              type='number'
              min='0'
              defaultValue='3'
              className='Input'
              name='reported_count'
              placeholder='Reported Count'
              required
            />

            <div className='BannedWordModal__form__buttons'>
              <a
                className='Button Button--gray-light'
                onClick={() => {
                  reportModalSet(false)
                }}
              >
                Cancel
              </a>

              <button className='Button Button--blue'>
                Update
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default PostsList
